export default __webpack_public_path__ + "static/media/home2.46722e86.jpg";